import { useState } from 'react';
import { academicYearSchema } from './utils';

export const useAcademicYearValidation = () => {
  const [errors, setErrors] = useState<{
    startDate?: string;
    endDate?: string;
  }>({});

  const validate = async (values: { startDate: string; endDate: string }) => {
    try {
      await academicYearSchema.validate(values, { abortEarly: false });
      setErrors({});
      return true;
    } catch (validationError: any) {
      const newErrors: { startDate?: string; endDate?: string } = {};
      validationError.inner.forEach((err: any) => {
        if (err.path)
          newErrors[err.path as 'startDate' | 'endDate'] = err.message;
      });
      setErrors(newErrors);
      return false;
    }
  };

  return { errors, setErrors, validate };
};
